
import React, { Component } from 'react';
import { Box } from 'reactjs-admin-lte'
import { Pagination, Form, FormGroup, Button } from 'react-bootstrap'
import { momentHelper } from '../helpers'
import SelectDate from 'component/element/SelectDate'
import Select from 'react-select'
import PrintButtons from 'component/element/PrintButtons'
import ReportStore from 'stores/ReportStore'
import XLSX from 'xlsx'
import FileSaver from 'file-saver'
import FontAwesome from 'react-fontawesome'
import DatePicker from 'component/element/DatePicker'
import IframeModal from 'component/element/IframeModal'
import Moment from 'moment'
import '../report.css'

const localStorageKey = 'kkc.report-post-payment'
class ReportPostPayment extends Component {
  constructor(props) {
    super(props)
    const WHOLE_YEAR = momentHelper.getMonth() //'00'

    this.state = {
      loading:false,
      activePage:1,
      opt:'all',
      optList:[{label:'ทั้งหมด',value:'all'},{label:'เจ้าของรถ(บุคคล)',value:'person'},{label:'เจ้าของ(บริษัท)',value:'company'},{label:'บริษัทประกัน',value:'insurer'}],
      opt1:'all',
      opt1List:[],
      month:WHOLE_YEAR,
      year:momentHelper.getYear(),
      data:[],
      isRange:false,
      day:momentHelper.getDay(),
      dayRange:momentHelper.getDay(),
      monthRange:WHOLE_YEAR,
      yearRange:momentHelper.getYear(),
      sort: JSON.parse(localStorage.getItem(localStorageKey)) || {sortStatus:'',sortStatus2:'',sortStatus3:'',sortStatus4:'',sortStatus5:''}
    }
    this.refTableId = 'ReportPostPayment-'+Math.ceil(Math.random()*100);
  }

  componentDidMount(){
   
  }

  componentWillReceiveProps(newProps){
    if(newProps.show && newProps.show!==this.props.show){
      this.loadData(this.state.year,this.state.month,this.state.day,this.state.opt,this.state.opt1)
      this.loadSalesTaxCustomerList(this.state.year,this.state.month,this.state.day,this.state.opt)
    }
  }

  getAllDayOfMonth(date) {
    const all_day = Moment(date, "YYYY-MM").daysInMonth()
    if (all_day) {
      if (all_day<this.state.day) {
        var defaultDay = '00'
      } else {
        var defaultDay = this.state.day
      }
    } else {
      var defaultDay = '00'
    }
    return defaultDay
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  getSummary(field) {
    let {data} = this.state
    let total = 0
    data.forEach((item,index)=> {
        total += (item[field]===''||item[field]===null||item[field]===undefined||isNaN(item[field])?0:item[field]*1)
    }) 
    return total
  }

  loadSalesTaxCustomerList(year='',month='',day='',opt='') {
      let opt1List = []
      opt1List.push({label:'ทั้งหมด',value:'all'})
      ReportStore.loadPostPaymentCustomerList(year,month,day,opt,(result)=>{
        result.data.forEach((item,index)=>{
            opt1List.push({label:item.name,value:item.name})
        })
        this.setState({opt1List:opt1List,opt1:'all'})
      })
  }

  loadSalesTaxCustomerListRange(start,end,opt) {
    let opt1List = []
    opt1List.push({label:'ทั้งหมด',value:'all'})
    ReportStore.loadPostPaymentCustomerListRange(start,end,opt,(result)=>{
      result.data.forEach((item,index)=>{
          opt1List.push({label:item.name,value:item.name})
      })
      this.setState({opt1List:opt1List,opt1:'all'})
    })
  }

  loadData(year='',month='',day='',opt='',opt1='') {
    let {sort} = this.state
    this.setState({loading:true,isRange:false,dayRange:momentHelper.getDay(),monthRange:month,yearRange:year})
    ReportStore.loadReportPostPayment(year,month,day,opt1,(result)=>{
      let data = result.data
      if (sort.sortStatus===''&&sort.sortStatus2===''&&sort.sortStatus3===''&&sort.sortStatus4===''&&sort.sortStatus5==='') {  
        data = result.data
      } else {
        if (sort.sortStatus!=='') {
          if (sort.sortStatus===''||sort.sortStatus==='desc') {
            data.sort()  
            data.reverse(function(a, b) {
                if(a['payment_date'] < b['payment_date']) return -1;
                if(a['payment_date'] > b['payment_date']) return 1;
                return 0;
            })
          } else if (sort.sortStatus==='asc') {
            data.reverse()  
            data.sort(function(a, b) {
                if(a['payment_date'] < b['payment_date']) return -1;
                if(a['payment_date'] > b['payment_date']) return 1;
                return 0;
            })
          }
        } else if (sort.sortStatus2!=='') {
          if (sort.sortStatus2===''||sort.sortStatus2==='desc') {
            data.sort()
            data.reverse(function(a, b) {
                if(a['doc_type_text'] < b['doc_type_text']) return -1;
                if(a['doc_type_text'] > b['doc_type_text']) return 1;
                return 0;
            })
          } else if (sort.sortStatus2==='asc') {
            data.reverse()  
            data.sort(function(a, b) {
                if(a['doc_type_text'] < b['doc_type_text']) return -1;
                if(a['doc_type_text'] > b['doc_type_text']) return 1;
                return 0;
            })
          }
        } else if (sort.sortStatus3!=='') {
            if (sort.sortStatus3===''||sort.sortStatus3==='desc') {
              data.sort()  
              data.reverse(function(a, b) {
                  if(a['doc_no'] < b['doc_no']) return -1;
                  if(a['doc_no'] > b['doc_no']) return 1;
                  return 0;
              })
            } else if (sort.sortStatus3==='asc') {
              data.reverse()  
              data.sort(function(a, b) {
                  if(a['doc_no'] < b['doc_no']) return -1;
                  if(a['doc_no'] > b['doc_no']) return 1;
                  return 0;
              })
            }
        } else if (sort.sortStatus4!=='') {
            if (sort.sortStatus4===''||sort.sortStatus4==='desc') {
              data.sort()  
              data.reverse(function(a, b) {
                  if(a['work_no'] < b['work_no']) return -1;
                  if(a['work_no'] > b['work_no']) return 1;
                  return 0;
              })
            } else if (sort.sortStatus4==='asc') {
              data.reverse()  
              data.sort(function(a, b) {
                  if(a['work_no'] < b['work_no']) return -1;
                  if(a['work_no'] > b['work_no']) return 1;
                  return 0;
              })
            }
        } else if (sort.sortStatus5!=='') {
            if (sort.sortStatus5===''||sort.sortStatus5==='desc') {
              data.sort()  
              data.reverse(function(a, b) {
                  if(a['car_registration_no'] < b['car_registration_no']) return -1;
                  if(a['car_registration_no'] > b['car_registration_no']) return 1;
                  return 0;
              })
            } else if (sort.sortStatus5==='asc') {
              data.reverse()  
              data.sort(function(a, b) {
                  if(a['car_registration_no'] < b['car_registration_no']) return -1;
                  if(a['car_registration_no'] > b['car_registration_no']) return 1;
                  return 0;
              })
            }
        }
      }
      this.setState({loading:false,data:data})
    })
  }

  loadDataRange(start='',end='',opt='',opt1='') {
    ReportStore.loadReportPostPaymentRange(start,end,opt1,(result)=>{
      this.setState({loading:false,data:result.data})
    })
  }

  renderBody() {
    let {data} = this.state
    if (data.length==0) {
      return(<tr><td colSpan={11}>ไม่พบข้อมูล</td></tr>)
    } else {
      return(
        data.map((item,index)=>
            <tr key={index}>
              <td className='text-center'>{item.payment_date}</td>
              <td className='text-center'>{item.doc_type_text}</td>
              <td className='text-center'>{item.doc_no}</td>
              <td className='text-center'>{item.work_no}</td>
              <td className='text-center'>{item.car_registration_no}</td>
              <td className='text-center'>{item.brand}</td>
              <td className='text-center'>{item.model}</td>
              <td className='text-center'>{item.customer_name}</td>
              <td className='text-right'>{this.getNumberFormat(item.amount)}</td>
              <td className='text-right'>{this.getNumberFormat(item.approved_amount)}</td>
              <td className='text-right'>{this.getNumberFormat(item.payment_amount)}</td>
            </tr>
        )
      )
    }
  }

  getDate() {
    let {day,year,month,isRange,dayRange,monthRange,yearRange} = this.state
    if (isRange) {
      let start = (day<10?'0'+day:day)+'/'+(month=='00'?'1':month)+'/'+year
      let end = dayRange+'/'+(monthRange<10?'0'+monthRange:monthRange)+'/'+yearRange
      return 'ประจำวันที่ '+start+' - '+end
    } else {
      let text = 'ประจำวันที่ '
      text += day+' '+momentHelper.getMonthText(month)+' '+year
      if (year==='0'||year==='00'||year===0) {
        text = 'ทั้งหมด'
      } else if (month==='0'||month==='00'||month===0) {
        text = 'ประจำปี '+year
      } else if (day==='0'||day==='00'||day===0) {
        text = 'ประจำเดือน '+momentHelper.getMonthText(month)+' '+year
      }
      return text
    }  
  }

  renderTable() {
    let {sort} = this.state
    return (
      <div className='display-overflow'>
        <table id={this.refTableId} className='table table-responsive table-bordered-solid table-hover'>
          <thead>
            <tr>
              <th style={{display:'none'}} className='text-center' colSpan={11}>รายงานสรุปยอดรับเงินแล้ว {this.getDate()}</th>
            </tr>
            <tr>
              <th className='text-center' style={{minWidth:'100px',width:'100px'}} onClick={this.onSortClick.bind(this,'payment_date')}>วันที่ชำระเงิน&nbsp;<FontAwesome className={'pull-right'} name={(sort.sortStatus===''?'sort':sort.sortStatus==='asc'?'sort-asc':sort.sortStatus==='desc'?'sort-desc':'sort')} /></th>
              <th className='text-center' style={{minWidth:'100px',width:'100px'}} onClick={this.onSortClick.bind(this,'doc_type_text')}>ประเภท&nbsp;<FontAwesome className={'pull-right'} name={(sort.sortStatus2===''?'sort':sort.sortStatus2==='asc'?'sort-asc':sort.sortStatus2==='desc'?'sort-desc':'sort')} /></th>
              <th className='text-center' style={{minWidth:'100px',width:'100px'}} onClick={this.onSortClick.bind(this,'doc_no')}>เลขเอกสาร&nbsp;<FontAwesome className={'pull-right'} name={(sort.sortStatus3===''?'sort':sort.sortStatus3==='asc'?'sort-asc':sort.sortStatus3==='desc'?'sort-desc':'sort')} /></th>
              <th className='text-center' style={{minWidth:'100px',width:'100px'}} onClick={this.onSortClick.bind(this,'work_no')}>ใบงานเลขที่&nbsp;<FontAwesome className={'pull-right'} name={(sort.sortStatus4===''?'sort':sort.sortStatus4==='asc'?'sort-asc':sort.sortStatus4==='desc'?'sort-desc':'sort')} /></th>
              <th className='text-center' style={{minWidth:'110px',width:'110px'}} onClick={this.onSortClick.bind(this,'car_registration_no')}>ทะเบียนรถ&nbsp;<FontAwesome className={'pull-right'} name={(sort.sortStatus5===''?'sort':sort.sortStatus5==='asc'?'sort-asc':sort.sortStatus5==='desc'?'sort-desc':'sort')} /></th>
              <th className='text-center' style={{minWidth:'100px',width:'100px'}}>ยี่ห้อ</th>
              <th className='text-center' style={{minWidth:'90px',width:'90px'}}>รุ่น</th>
              <th className='text-center' style={{minWidth:'110px',width:'110px'}}>ชื่อลูกค้า</th>
              <th className='text-center' style={{minWidth:'80px',width:'80px'}}>ราคาเสนอ</th>
              <th className='text-center' style={{minWidth:'80px',width:'80px'}}>ราคาอนุมัติ</th>
              <th className='text-center' style={{minWidth:'80px',width:'80px'}}>ยอดชำระ</th>
            </tr>
          </thead>
          <tbody>
            {this.renderBody()}
          </tbody>
          <tfoot>
            <tr>
              <th colSpan={8} className='text-right'>ยอดรวมสุทธิ</th>
              <th className='text-right'>{this.getNumberFormat(this.getSummary('amount'))}</th>
              <th className='text-right'>{this.getNumberFormat(this.getSummary('approved_amount'))}</th>
              <th className='text-right'>{this.getNumberFormat(this.getSummary('payment_amount'))}</th>
            </tr>
          </tfoot>
        </table>
      </div>
    )
  }

  onSortClick(key,e) {
    let {data,sort} = this.state
    if (data!==undefined&&data.length>1) {
      if (key==='payment_date') { 
        if (sort.sortStatus===''||sort.sortStatus==='desc') {
          sort.sortStatus = 'asc'
          data.sort(function(a, b) {
            if(a['payment_date'] < b['payment_date']) return -1;
            if(a['payment_date'] > b['payment_date']) return 1;
            return 0;
          })
        } else if (sort.sortStatus==='asc') {
          sort.sortStatus = 'desc'
          data.reverse(function(a, b) {
            if(a['payment_date'] < b['payment_date']) return -1;
            if(a['payment_date'] > b['payment_date']) return 1;
            return 0;
          })
        }
        sort.sortStatus2 = ''
        sort.sortStatus3 = ''
        sort.sortStatus4 = ''
        sort.sortStatus5 = ''
      } else if (key==='doc_type_text') { 
        if (sort.sortStatus2===''||sort.sortStatus2==='desc') {
          sort.sortStatus2 = 'asc'
          data.sort(function(a, b) {
            if(a['doc_type_text'] < b['doc_type_text']) return -1;
            if(a['doc_type_text'] > b['doc_type_text']) return 1;
            return 0;
          })
        } else if (sort.sortStatus2==='asc') {
          sort.sortStatus2 = 'desc'
          data.reverse(function(a, b) {
            if(a['doc_type_text'] < b['doc_type_text']) return -1;
            if(a['doc_type_text'] > b['doc_type_text']) return 1;
            return 0;
          })
        }
        sort.sortStatus = ''
        sort.sortStatus3 = ''
        sort.sortStatus4 = ''
        sort.sortStatus5 = ''
      } else if (key==='doc_no') { 
        if (sort.sortStatus3===''||sort.sortStatus3==='desc') {
          sort.sortStatus3 = 'asc'
          data.sort(function(a, b) {
            if(a['doc_no'] < b['doc_no']) return -1;
            if(a['doc_no'] > b['doc_no']) return 1;
            return 0;
          })
        } else if (sort.sortStatus3==='asc') {
          sort.sortStatus3 = 'desc'
          data.reverse(function(a, b) {
            if(a['doc_no'] < b['doc_no']) return -1;
            if(a['doc_no'] > b['doc_no']) return 1;
            return 0;
          })
        }
        sort.sortStatus = ''
        sort.sortStatus2 = ''
        sort.sortStatus4 = ''
        sort.sortStatus5 = ''
      } else if (key==='work_no') { 
        if (sort.sortStatus4===''||sort.sortStatus4==='desc') {
          sort.sortStatus4 = 'asc'
          data.sort(function(a, b) {
            if(a['work_no'] < b['work_no']) return -1;
            if(a['work_no'] > b['work_no']) return 1;
            return 0;
          })
        } else if (sort.sortStatus4==='asc') {
          sort.sortStatus4 = 'desc'
          data.reverse(function(a, b) {
            if(a['work_no'] < b['work_no']) return -1;
            if(a['work_no'] > b['work_no']) return 1;
            return 0;
          })
        }
        sort.sortStatus = ''
        sort.sortStatus2 = ''
        sort.sortStatus3 = ''
        sort.sortStatus5 = ''
      } else if (key==='car_registration_no') { 
        if (sort.sortStatus5===''||sort.sortStatus5==='desc') {
          sort.sortStatus5 = 'asc'
          data.sort(function(a, b) {
            if(a['car_registration_no'] < b['car_registration_no']) return -1;
            if(a['car_registration_no'] > b['car_registration_no']) return 1;
            return 0;
          })
        } else if (sort.sortStatus5==='asc') {
          sort.sortStatus5 = 'desc'
          data.reverse(function(a, b) {
            if(a['car_registration_no'] < b['car_registration_no']) return -1;
            if(a['car_registration_no'] > b['car_registration_no']) return 1;
            return 0;
          })
        }
        sort.sortStatus = ''
        sort.sortStatus2 = ''
        sort.sortStatus3 = ''
        sort.sortStatus4 = ''
      }
      let config = {sortStatus:sort.sortStatus,sortStatus2:sort.sortStatus2,sortStatus3:sort.sortStatus3,sortStatus4:sort.sortStatus4,sortStatus5:sort.sortStatus5}
      localStorage.setItem(localStorageKey, JSON.stringify(config))
      this.setState({data:data,sort:sort})
    }  
  }

  onPageSelect(eventKey) {
    this.setState({
      activePage: eventKey
    })
    // next... load new page
  }

  onDayChange(val){
    this.setState({
      day: val.value, isRange:false
    })
    this.loadData(this.state.year,this.state.month,val.value,this.state.opt,this.state.opt1)
    this.loadSalesTaxCustomerList(this.state.year,this.state.month,val.value,this.state.opt)
  }

  onMonthChange(val) {
    let date = this.state.year-543+'-'+val.value
    let _day = '00'
    _day = this.getAllDayOfMonth(date)
    this.setState({
      month: val.value, isRange: false, day: _day
    })
    this.loadData(this.state.year,val.value,_day,this.state.opt,this.state.opt1)
    this.loadSalesTaxCustomerList(this.state.year,val.value,_day,this.state.opt)
  }

  onYearChange(val) {
    let date = val.value-543+'-'+this.state.month
    let _day = '00'
    _day = this.getAllDayOfMonth(date)
    this.setState({
      year: val.value, isRange: false, day: _day
    })
    this.loadData(val.value,this.state.month,_day,this.state.opt,this.state.opt1)
    this.loadSalesTaxCustomerList(val.value,this.state.month,_day,this.state.opt)
  }

  onOptChange(val) {
    this.setState({
      opt: val.value, isRange: false
    })
    this.loadData(this.state.year,this.state.month,this.state.day,val.value,this.state.opt1)
    this.loadSalesTaxCustomerList(this.state.year,this.state.month,this.state.day,val.value)
  }

  onOpt1Change(val) {
    let {isRange} = this.state
    this.setState({
      opt1: val.value
    })
    if (isRange) {
        const start = (this.state.day=='00'?this.state.dayRange:this.state.day)+'/'+this.state.month+'/'+this.state.year
        const end = this.state.dayRange+'/'+this.state.monthRange+'/'+this.state.yearRange
        this.loadDataRange(start,end,this.state.opt,val.value)
    } else {
        this.loadData(this.state.year,this.state.month,this.state.day,this.state.opt,val.value)
    }    
  }

  onExportExcel(e) {
    const worksheet = XLSX.utils.table_to_book(document.getElementById(this.refTableId));
    let wbout = XLSX.write(worksheet, { bookType: 'xlsx', bookSST: true, type: 'binary' });

    function s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
      return buf;
    }    
    const fileName = 'รายงานสรุปยอดรับเงินแล้ว.xlsx'
    FileSaver.saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), fileName) 
    this.setState({showExport:false})
  }

  onPrintTable(e) {
    const {isRange} = this.state
    let url = ''
    let param = 'PrintReportPostPayment&year='+this.state.year+'&month='+this.state.month+'&day='+this.state.day+'&name='+this.state.opt1+'&isRange=false'
    if (isRange) {
        let {day,month,year,dayRange,monthRange,yearRange} = this.state
        let start = day+'/'+(month=='00'?'1':month)+'/'+(year-543)
        let end = dayRange+'/'+monthRange+'/'+(yearRange-543)
        param = 'PrintReportPostPayment&start_date='+start+'&end_date='+end+'&name='+this.state.opt1+'&isRange=true'
    }    

    if (process.env.NODE_ENV == "development") {
      url  = './?startPage='+param
    } else{
      url = './pdf/v2/?startPage='+param
    }
    this.refs.iframe.loadUrl(url)
  }

  onStartDateRangeChange(time) {
    if (time!=''&&time!=undefined&&time!=null) {
      let _day = time.substr(0,2)
      let _month = time.substr(3,2)
      let _year = time.substr(6,10)
      this.setState({day:_day*1,month:_month,year:_year*1,isRange:false})
      this.loadData(_year,_month,_day,this.state.opt,this.state.opt1)
      this.loadSalesTaxCustomerList(_year,_month,_day,this.state.opt)
    }
  }

  onEndDateRangeChange(time) {
    if (time!=''&&time!=undefined&&time!=null) {
      let {day,month,year} = this.state
      let _day = parseInt(time.substr(0,2))
      let _month = parseInt(time.substr(3,5))
      let _year = parseInt(time.substr(6,10))
      this.setState({isRange:true,dayRange:_day,monthRange:_month,yearRange:_year})
      year = year - 543
      _year = _year - 543
      let start = day+'/'+(month=='00'?'1':month)+'/'+year
      let end = _day+'/'+_month+'/'+_year
      this.loadDataRange(start,end,this.state.opt,this.state.opt1)
      this.loadSalesTaxCustomerListRange(start,end,this.state.opt)
    }  
  }

  onRangeChange(fromDateString,toDateString,items) {
    let {day,month,year,dayRange,monthRange,yearRange} = this.state
    day = items.from.format('DD')*1
    month = items.from.format('MM')
    year = (items.from.format('YYYY')*1)+543
    dayRange = items.to.format('DD')*1
    monthRange = items.to.format('MM')
    yearRange = (items.to.format('YYYY')*1)+543
    this.setState({isRange:true,day:day,month:month,year:year,dayRange:dayRange,monthRange:monthRange,yearRange:yearRange})
    const start = day+'/'+month+'/'+items.from.format('YYYY')
    const end = dayRange+'/'+monthRange+'/'+items.to.format('YYYY')
    this.loadDataRange(start,end,this.state.opt,this.state.opt1)
    this.loadSalesTaxCustomerListRange(start,end,this.state.opt)
  }

  renderWCalendar() {
    return(
          <div style={{display:'inline-flex'}}>
              <DatePicker 
                style={{display:'inline-block'}}
                height={'36px'}
                none={true}
                showIcon={true}
                showFooter={true}
                popPlacement='bottom'
                buddhistEra
                value={(this.state.day=='00'?this.state.dayRange:this.state.day)+'/'+this.state.month+'/'+this.state.year}
                onChange={this.onStartDateRangeChange.bind(this)}
                maxWidth={'100%'}
                onRangeChange={this.onRangeChange.bind(this)}
            />
            <DatePicker 
                style={{display:'inline-block'}}
                height={'36px'}
                none={true}
                showIcon={true}
                showFooter={true}
                popPlacement='bottom'
                buddhistEra
                value={this.state.dayRange+'/'+this.state.monthRange+'/'+this.state.yearRange}
                onChange={this.onEndDateRangeChange.bind(this)}
                maxWidth={'100%'}
                onRangeChange={this.onRangeChange.bind(this)}
            />
          </div>
    )      
  }

  renderToolbar() {
    return(
      <Form inline>
        <FormGroup style={{verticalAlign:'top'}}>
          <SelectDate
            wholeYear={true}
            year={this.state.year}
            month={this.state.month}
            day={this.state.day}
            onMonthChange={this.onMonthChange.bind(this)}
            onYearChange={this.onYearChange.bind(this)}
            onDayChange={this.onDayChange.bind(this)}
            dayWCalendar={true}
            renderWCalendar={this.renderWCalendar.bind(this)}
          />
        </FormGroup>  
        <div style={{ width: '150px', display: 'inline-block', marginLeft:'5px' }}>
          <Select
            clearable={false}
            name="form-field-name"
            value={this.state.opt}
            options={this.state.optList}
            onChange={this.onOptChange.bind(this)}
          />
        </div>
        <div style={{ width: '250px', display: 'inline-block', marginLeft:'5px' }}>
          <Select
            clearable={false}
            name="form-field-name"
            value={this.state.opt1}
            options={this.state.opt1List}
            onChange={this.onOpt1Change.bind(this)}
          />
        </div>
        <FormGroup style={{verticalAlign:'top',marginLeft:'5px',marginTop:'1.5px'}}>
          <PrintButtons
            onPrintTable={this.onPrintTable.bind(this)}
            onExportExcel={this.onExportExcel.bind(this)}
            marginLeft='0'
            width='auto'
          />
        </FormGroup>
      </Form>
    )
  }

  renderPaging() {
    return (
      <div className="text-center pull-right">
        <Pagination
          prev
          next
          first
          last
          bsSize="medium"
          items={5}
          activePage={this.state.activePage}
          onSelect={this.onPageSelect.bind(this)} />
      </div>
    )
  }

  getStartDateRangeText() {
    let {day,month,year} = this.state
    let txtMonth = momentHelper.getMonthText(month.toString())
    return day*1+' '+ txtMonth +' '+ year
  }

  getEndDateRangeText() {
    let {dayRange,monthRange,yearRange} = this.state
    dayRange = dayRange==0?1:dayRange
    let txtMonth = momentHelper.getMonthText(monthRange.toString())
    return dayRange +' '+ txtMonth +' '+ yearRange
  }

  onRangeClearClick() {
    this.loadData(this.state.year,this.state.month,this.state.day,this.state.opt,this.state.opt1)
    this.loadSalesTaxCustomerList(this.state.year,this.state.month,this.state.day,this.state.opt)
    this.setState({isRange:false,dayRange:momentHelper.getDay(),monthRange:this.state.month,yearRange:this.state.year})
  }

  renderDateRange() {
    let {isRange} = this.state
    if (isRange) {
      return(
        <div style={{marginBottom:'10px',display:'flex'}}>
          {this.getStartDateRangeText()} - {this.getEndDateRangeText()}&nbsp;<Button className='btn btn-xs' onClick={this.onRangeClearClick.bind(this)}><FontAwesome name='eraser' />&nbsp;ลบช่วงเวลา</Button>
        </div>
      )
    } else {
      return('')
    }  
  }

  render() {
    const reportName = 'รายงานสรุปยอดรับเงินแล้ว'
    const reportDateText = momentHelper.getMonthText(this.state.month) + " " + this.state.year
    const title = reportName + ' ' + reportDateText
    const {loading} = this.state
    return (
      <Box loading={loading}>
        <Box.Header border={true}>          
          {this.props.renderMenu()}
        </Box.Header>
        <Box.Body>
          {this.renderToolbar()}
          {this.renderDateRange()}
          {this.renderTable()}
          {/*this.renderPaging()*/}
          <IframeModal ref='iframe' title={'พิมพ์เอกสาร'} />
        </Box.Body>
      </Box>
    )
  }
}

ReportPostPayment.defaultProps = {
  show : false
}

export default ReportPostPayment;


// WEBPACK FOOTER //
// ./src/view/report/finance/ReportPostPayment.js